/*******************************************************************************
BUILD A ITEM EDIT MODAL WINDOW
*******************************************************************************/

export default function buildItemEditModal(options) {

    // All the different options that can be passed in
    const title = options.title || 'Edit Item';
    const itemID = options.itemID || '';
    const itemName = options.itemName || 'item';
    const itemValue = options.itemValue || '';
    const maxlength = options.maxlength || '';
    const cancelButton = options.cancelButton || 'Cancel';
    const saveButton = options.saveButton || 'Save';
    const saveClass = options.saveClass || '';
    const includeBackground = (options.includeBackground === undefined) ? true : options.includeBackground;

    const modalHTML = `
    <div class="modal">
        <div class="modal__head">${title}</div>
        <div class="modal__main">
            <input data-origval="${itemValue}" class="modal__input" type="text" name="${itemName}" value="${itemValue}" maxlength="${maxlength}">
            <div class="modal__error hide"></div>
            <div class="modal__actions">
                <button class="btn size-1 pad-2 danger-outline close-modal upper">${cancelButton}</button>
                <button data-itemid="${itemID}" data-inprogress="Saving..." class="${saveClass} btn size-1 pad-2 primary upper bold">${saveButton}</button>
            </div>
        </div>
    </div>`;

    return (includeBackground) ? `<div class="modal-background">${modalHTML}</div>` : modalHTML;
}
